import React from 'react'
import L from 'react-loadable'
import { Dimmer, Loader, } from 'semantic-ui-react'

const Loading = () => (
    // <div>Loading...</div>
    <Dimmer active>
        <Loader size='large'>Loading</Loader>
    </Dimmer>
)

export default opts => L({
    loading: Loading,
    ...opts
})


// WEBPACK FOOTER //
// ./src/features/ui/components/Loadable.js